import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const EditLocationMasterModal = ({ isOpen, onClose, editFormData, setEditFormData, branches }) => {
  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
        Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
      const response = await axios.put(`https://rfs2.infraconsoft.net.in/api/veh_location_edit/${editFormData.id}`, {
        locationBranch: editFormData.locationBranch,
        location: editFormData.location,
        id : editFormData.id,
      });

     
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Location Updated successfully.",
        });
        onClose();
        window.location.reload();
      } else {
        console.warn("Insert failed, no 'success' in response:", response.data);
        Swal.fire({
          icon: "error",
          title: "Insert Failed",
          text: response.data.message || "Unknown error.",
        });
      }
      
     } catch (error) {
      console.error("Error inserting location:", error);
    
      if (error.response && error.response.data && error.response.data.message) {
        Swal.fire({
          icon: "error",
          title: "Insert Failed",
          text: error.response.data.message,  // <-- duplicate message will show here
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Insert failed. Please try again.",
        });
      }
    }
  };

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <button className="close-btn" onClick={onClose} style={{position: "initial"}}>&times;</button>
    </div>
        <h3>Edit Location List</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>

        <div className="form-row">
            <div className="form-group">
                <label>Branch :</label>
                <select name="locationBranch" value={editFormData.locationBranch} onChange={handleEditChange} className="branch-select">
          <option value="">Select Branch</option>
          {branches.map((item) => (
            <option key={item.branchMaster_code} value={item.branchMaster_code}>
              {item.branchMaster_name}
            </option>
          ))}
        </select>
              </div> 
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Location :</label>
                <input
            type="text"
            name="location"
            value={editFormData.location}
            onChange={handleEditChange}
          />
              </div> 
            </div>


            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Update
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default EditLocationMasterModal;
